<template>
  <div
    v-if="links.length"
    class="col-2"
  >
    <div class="shadow-sm rounded">
      <el-menu :default-active="submenuRoute">
        <el-menu-item
          v-for="link in links"
          :key="link.route"
          :index="route(link.route)"
          @click="menuClick"
        >
          <i
            v-if="link.icon"
            :class="link.icon"
          />
          {{ link.title }}
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiSidebar',
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    submenuRoute() {
      try {
        const [module, action] = route().current().split('.');
        if (action !== 'index') {
          return route(`${module}.${action}.index`);
        }
        return route(`${module}.index`);
      } catch (e) {
        return route().current();
      }
    },
  },
  methods: {
    menuClick(item) {
      this.$inertia.visit(item.index);
    },
  },
};
</script>

<style scoped>

</style>
